import styles from "./HeaderImplant.module.scss";
import implantPicture from '../../../shared/assets/photo/implant/implant_1x.png';
import implantPicture_2x from '../../../shared/assets/photo/implant/implant_2x.png';
import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import implantPictureMob from '../../../shared/assets/photo/implant/implantMob.png';
import implantPictureMob_2x from '../../../shared/assets/photo/implant/implantMob_2x.png';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP); 

const HeaderImplant = () => {

    useGSAP(() => {
        gsap.fromTo(".implant__header", {opacity: 0,  y:10,}, 
                                    { opacity: 1,
                                    y:0,  
                                    duration: 1, 
                                    });
    }, [])

    return ( 
        <div>
            <div className={styles.content}>
                <img className={styles.picture} src={implantPicture}
                    srcSet={`${implantPicture_2x} 2x`} alt="эстетическая стоматология" />

                <img className={styles.pictureMob} src={implantPictureMob}
                    srcSet={`${implantPictureMob_2x} 2x`} alt="эстетическая стоматология" />
            <Stack              
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.header}>
                    <Text
                        type='h1' 
                        size ='xxl'
                        className={`implant__header ${styles.title}`}>
                            Хирургия и имплантация
                    </Text>
            </Stack>
        </div>
        </div>
    );
}
export default HeaderImplant;